// Remembers every ability timing the user has typed or loaded, so the ability
// editor can suggest them. Shared module-level state (all ability editors see the
// same set) and persisted to localStorage so suggestions survive reloads.
import { createSuggestionStore } from './useSuggestionStore.js';

export const useTimingSuggestions = createSuggestionStore('studio:abilityTimings', {
  // "Passive" is a placeholder for passive abilities, not a real timing.
  skip: (value) => value.toLowerCase() === 'passive',
});
